import { useMutation, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { toast } from "react-toastify";
import billerHttp from "../../../utils/billerHttp";
import { removeEmptyKeys } from "../../../utils/removeEmptyFromObjectOrArray";

type Payload = {
  firstName: string
  lastName: string
  middleName?: string
  title: string
  email: string
  providerNPI: string
  providerTaxId: string
  phoneNumber: string
}

export const useAddExternalProvider = () => {
  const queryClient = useQueryClient();

  const { mutate, data, variables, reset, ...rest } = useMutation({
    mutationKey: ['add external providers'],
    mutationFn: async ({ ...data }: Payload) => {
      const newobj = removeEmptyKeys(data)
      const response = await billerHttp.post('billers/external-provider', newobj);
      return response.data;
    },

    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['get all biller providers'] as const
      });
      toast.success("Provider added");
    },

    onError: (error) => {
      if (axios.isAxiosError(error)) {
        toast.error(
          error?.response?.data?.error || error.response?.statusText,
        );
      } else {
        toast.error(
          error?.message
          || "Error adding provider, try again or contact admin",
        );
      }
    },
  });

  return {
    addExternalProvider: mutate,
    variables,
    ...rest,
  };
}
